<div class="row-layout-track">
    <div class="largecard-layout-box__100pct">
        <large-card
            [largeCardInteriorOptions]="this.chartCardInfo.largeCardInteriorOptions"
        ></large-card>
    </div>
</div>
